import { List, ThemeIcon } from '@mantine/core';
import { IconCircleCheck, IconCircleDashed } from '@tabler/icons-react';

export type CheckListItem = {
  value?: string | number | boolean | null;
  label: string;
  unit?: string;
  optional?: boolean;
  state?: 'error' | 'warning' | 'success';
};

interface CheckListProps {
  items: CheckListItem[];
  withIcon?: boolean;
}

const icons = {
  success: IconCircleCheck,
  warning: IconCircleDashed,
  error: IconCircleDashed,
};

export function CheckList({ items, withIcon = true }: CheckListProps) {
  return (
    <List spacing="xs" withPadding>
      {items.map((item) => {
        const state = item.state || (item.value ? 'success' : 'error');
        const color =
          state === 'success'
            ? 'pf-green'
            : item.optional || state === 'warning'
              ? 'yellow'
              : 'red';
        const Icon = icons[state];

        return (
          <List.Item
            icon={
              withIcon ? (
                <ThemeIcon color={color} radius="xl" size="sm">
                  <Icon style={{ width: '90%', height: '90%' }} />
                </ThemeIcon>
              ) : null
            }
            key={item.label}
            style={{
              listStyleType: 'none',
            }}
          >
            {item.label} : {item.value || '-'} {item.value ? item.unit : ''}
          </List.Item>
        );
      })}
    </List>
  );
}

export default CheckList;
